export const zfComponentThemeOverrides = {
  MuiSwitch: {
    styleOverrides: {
      switchBase: (props: any) => {
        const { theme } = props;

        return {
          '& .MuiSwitch-thumb': {
            color: `${theme.palette.error.main} !important`,
          },

          '&.Mui-checked .MuiSwitch-thumb': {
            color: `${theme.palette.success.main} !important`,
          },

          '&.Mui-checked.Mui-disabled .MuiSwitch-thumb': {
            color: `${theme.palette.success.light} !important`,
          },

          '&.Mui-disabled .MuiSwitch-thumb': {
            color: `${theme.palette.error.light} !important`,
          },

          '& + .MuiSwitch-track': {
            backgroundColor: `${theme.palette.error.main} !important`,
          },

          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: `${theme.palette.success.main} !important`,
          },

          '&.Mui-checked.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: `${theme.palette.success.light} !important`,
          },

          '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: `${theme.palette.error.light} !important`,
          },
        };
      },
    },
  },
};
